import React from 'react';
import { bool, string } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

export const ListTitle = ({
  disableLink,
  url,
  listNameIsLong,
  shortListName,
  listName
}) => {
  const titleElement = (
    <Typography
      variant="h3"
      weight="bold"
    >
      {listNameIsLong ? shortListName : listName}
    </Typography>
  );

  return disableLink ? titleElement : <a href={url}>{titleElement}</a>;
};

ListTitle.propTypes = {
  disableLink: bool.isRequired,
  url: string,
  listNameIsLong: bool.isRequired,
  shortListName: string,
  listName: string
};

ListTitle.defaultProps = {
  url: '',
  shortListName: '',
  listName: ''
};
